/* eslint-disable import/no-unresolved */
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  IconButton,
} from '@mui/material';
import Icon from '@/components/Icon';
import CreateCustomerForm from '@/components/Forms/CreateCustomerForm';
import { selectModal } from '@/store/selectors';
import { closeModal } from '@/store/slices/modal';

const boxStyle = {
  position: 'absolute',
  height: '800px',
  width: '665px',
  backgroundColor: '#fff',
  borderRadius: '10px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 8,
};
const CreateCustomer = () => {
  const { createCustomer } = useSelector(selectModal);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(closeModal({ type: 'createCustomer' }));
  };

  return (
    <div>
      <Modal
        open={createCustomer}
        onClose={handleModalClose}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={createCustomer} mountOnEnter unmountOnExit>
          <Box sx={boxStyle}>
            <Box sx={{ textAlign: 'left', marginBottom: 6 }}>
              <IconButton
                onClick={handleModalClose}
                sx={{
                  border: '2px solid #E6E8EC',
                  width: '92px',
                  height: '40px',
                  borderRadius: '90px',
                  p: '12px 16px',
                }}
              >
                <Icon icon="arrowLeft" width={15} height={15} />
                <Typography
                  sx={{
                    fontWeight: 700,
                    marginLeft: 1,
                    color: (theme) => theme.general.black,
                  }}
                >
                  Back
                </Typography>
              </IconButton>
            </Box>
            <Typography
              variant="h4"
              sx={{ lineHeight: '16px', fontWeight: 700, textAlign: 'left' }}
            >
              Create new customer
            </Typography>
            <CreateCustomerForm />
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};

export default CreateCustomer;
